import { render } from "./ViewAdminLogin.vue?vue&type=template&id=70324500&scoped=true"
import script from "./ViewAdminLogin.vue?vue&type=script&lang=js"
export * from "./ViewAdminLogin.vue?vue&type=script&lang=js"

import "./ViewAdminLogin.vue?vue&type=style&index=0&id=70324500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70324500"]])

export default __exports__